<script setup>
defineProps({
  fees: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <div v-for="fee in fees" :key="fee.code || fee.label" class="product-card-key__price" data-cy="checkout-extra-fee">
    {{ fee.amount }} <span>{{ fee.label }}</span>
  </div>
</template>
